import {
    getAvailabilityStatus,
    deleteAvailabilityStatus,
    createAvailabilityStatus,
    updateAvailabilityStatus
} from '../../../services/AvailabilityStatusService';
import {
    CONFIRMED_GET_AVALIBILITY_STATUS
} from './AvailabilityStatusTypes';

export function getAvailabilityStatusAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
            dispatch({ type: 'AVAILABILITY_STATUS_LOADING' });
            getAvailabilityStatus(currentPage, pageSize, searchTerm, filterQuery)
                .then((response) => {
                    dispatch(confirmedGetAvailabilityStatusAction(response.data.data));
                })
                .catch(() => {
                    dispatch(confirmedGetAvailabilityStatusAction({ rows: [], count: 0, pages: 1 }));
                });
    };
}

export function confirmedGetAvailabilityStatusAction(data) {
    return {
        type: CONFIRMED_GET_AVALIBILITY_STATUS,
        payload: data,
    };
}

export function deleteAvailabilityStatusAction(id, history) {
    return (dispatch, getState) => {
        return deleteAvailabilityStatus(id).then((response) => {
            return response;
        });
    };
}

export function createAvailabilityStatusAction(data) {
    return () => {
        return createAvailabilityStatus(data).then((response) => {
            return response;
        });
    };
}

export function updateAvailabilityStatusAction(id, data) {
    return () => {
        return updateAvailabilityStatus(id, data).then((response) => {
            return response;
        });
    };
}

